import React from 'react';
import {ErrorBoundary} from "@soprisapps/components/components/utilities/ErrorBoundary";
import {SchoolFeedContent} from "@soprisapps/components/components/schoolfeed/SchoolFeedDisplay";
import AdminMenu from "@soprisapps/components/components/misc/AdminMenu";
import styles from "@soprisapps/components/pages/styles/SchoolFeedFullPage.module.scss";
import {useStores} from "@soprisapps/components/stores/useStores";
import SchoolFeedSearchFilters, {
    useSchoolFeedData
} from "@soprisapps/components/components/header/schoolfeed/SchoolFeedSearchFilter";
import {useSchoolFeedUrlQuery} from "@soprisapps/components/hooks/useSchoolFeedData";
import classNames from "classnames";
import schoolFeedDisplayStyles from "@soprisapps/components/components/schoolfeed/styles/SchoolFeedDisplay.module.scss";

const SchoolFeedFullPage = (props) => {
    const {interfaceStore, userStore} = useStores();

    const {contentCounts, urlQuery} = useSchoolFeedData()

    const displayContainerClassName = classNames({
        [schoolFeedDisplayStyles.displayContainer]: true,
        [schoolFeedDisplayStyles.displayContainerFiles]: urlQuery.type === 'files',
    });

    return (
        <ErrorBoundary>
            <main id={"sb-main-content"}>
                <SchoolFeedSearchFilters
                    className={styles.searchFilters}
                    contentCounts={contentCounts}
                />
                <div className={displayContainerClassName} data-current-view={urlQuery.currentView}>
                    <SchoolFeedContent
                        urlQuery={urlQuery}
                    />
                </div>
                {userStore.editor && <AdminMenu key={interfaceStore.currentFullUrl}/>}
            </main>
        </ErrorBoundary>
    );
};

export default SchoolFeedFullPage;
